<template>
  <!--Main Content-->
  <div class="main-content px-0 app-content">
    <!--Main Content Container-->
    <div class="container-fluid">
      <!--Page Header-->
      <Breadcrumb />
      <!--Page Header-->
      <div class="forms card rounded">
        <div
          v-bind:class="[closed ? 'close' : '']"
          class="mb-4 bg-warning p-3 text-dark"
          v-if="isSuccessful === false"
        >
          <b>Error : {{ errorMessage }}</b>
          <i @click="close()" class="fas fa-close"></i>
        </div>
        <div v-else></div>
        <form @submit.prevent="createDepartment()">
          <label>Select Company</label>
          <select required v-model="companyId" class="form-control mb-3">
            <option selected>Select Company</option>
            <option
              v-for="company in groupOfCompany"
              :key="company.id"
              :value="company.id"
            >
              {{ company.name }}
            </option>
          </select>

          <label>Department Name</label>
          <input v-model="name" type="text" class="form-control" required />

          <button type="submit" class="btn btn-primary">
            Create Department
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";

export default {
  components: {
    Breadcrumb,
  },

  props: ["user", "BaseURL"],
  data() {
    return {
      name: "",
      email: "",
      companyId: "",

      groupOfCompany: [],

      isSuccessful: "",
      errorMessage: "",

      closed: "",
    };
  },

  created() {
    fetch(this.BaseURL + "/getAllCompany", {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    })
      .then((res) => res.json())
      .then((data) => {
        //console.log(data)
        this.groupOfCompany = data;
      });
  },

  beforeCreate() {
    if (localStorage.getItem("role") !== "Admin") {
      window.location = "/error";
    }
  },

  methods: {
    createDepartment() {
      fetch(this.BaseURL + "/addDepartment", {
        method: "POST",
        body: JSON.stringify({
          name: this.name,
          companyId: this.companyId,
          submittedBy: this.user.email,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((res) => res.json())
        .then((data) => {
          this.isSuccessful = data.isSuccessful;
          this.errorMessage = data.message;

          if (this.isSuccessful == true) {
            window.location = "/departments";
          }
        });
    },

    close() {
      this.closed = true;
    },
  },
};
</script>